import React from 'react';
import { useEffect } from 'react';


//Zoho Sales Iq Script:
const useScript = (url, widgetCode) => {
    useEffect(() => {
    const script1 = document.createElement('script');
    script1.setAttribute("type", "text/javascript");

    let code = `window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}`
    // let code = `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "${widgetCode}", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="${url}";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);d.innerHTML = "<div id='zsiqwidget'></div>";
    // $zoho.salesiq.ready = function(embedinfo)
    // {
	//    $zoho.salesiq.floatbutton.coin.hidetooltip();
    //    $zoho.salesiq.customfield.add(
    //    {
    //       "name":"User ID",
    //       "hint":"User ID(Required)",
    //       "required":"true",
    //       "visibility":"both",
    //    });
    // }`
    
    script1.appendChild(document.createTextNode(code));
    const script2 = document.createElement('script');
    script2.setAttribute("type", "text/javascript");
    script2.id = "zsiqchat";
    script2.src=url+"?wc="+ widgetCode;
    script2.defer = true;
    document.body.appendChild(script1);
    document.body.appendChild(script2);
    
    return () => {
    document.body.removeChild(script1);
    document.body.removeChild(script2);
    }
}, [url]);
};

export default function ZohoLiveChat() {
    return (
        <React.Fragment>
            {useScript('https://salesiq.zohopublic.com/widget', 'siqb370f0a9486b28ab4ce57509d63c829abe892fbbe145eebde60c41486f088b58')}
        </React.Fragment>
    );
}